import React from "react";

const AwardIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.3608 22.3516L23.3293 33H16.7368L18.5732 22.4045L10.3954 29.3801L7.09253 23.6199L17.2389 20L7.09253 16.3801L10.3954 10.6199L18.6393 17.6616L16.7368 7H23.3293L21.3608 17.5955L29.6047 10.6199L32.9076 16.3933L22.7612 20.0132L32.9076 23.6331L29.6047 29.4065L21.3608 22.3648V22.3516Z" fill="#FF2626" stroke="#FF2626" stroke-miterlimit="10" />
    </svg>
);

export default AwardIcon;